



















































import { Component, Vue } from 'vue-property-decorator';
import { vxm } from './../store.vuex';
import { JobHistoryInfo } from '../models/jobs/jobhistoryinfo';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});

@Component({
  name: 'JobHistoryPager',
  components: {},
})
export default class JobHistoryPager extends Vue {
  $wlToastr: any;
  private errorString: string = '';
  private successString: string = '';
  private recsPerPage: number = 10;

  get isLastPage(): boolean {
    if (this.currentPage === this.pageCount) {
      return true;
    } else {
      return false;
    }
  }

  ///////////////////////////////////////////////

  get isFirstPage(): boolean {
    if (this.currentPage === 1) {
      return true;
    } else {
      return false;
    }
  }

  ///////////////////////////////////////////////

  get pageCount() {
    return vxm.jobs.JobHistoryPager.totalPages;
  }

  ///////////////////////////////////////////////

  get currentPage() {
    return vxm.jobs.JobHistoryPager.resultPage;
  }

  ///////////////////////////////////////////////

  reload() {
    const jhr = vxm.jobs.UserJobHistoryListRequest;
    jhr.resultSize = this.recsPerPage;
    vxm.jobs.getJobHistory(jhr);
  }

  ///////////////////////////////////////////////

  getNext() {
    if (this.currentPage < this.pageCount) {
      const jhr = vxm.jobs.UserJobHistoryListRequest;
      jhr.resultPage = this.currentPage + 1;
      jhr.resultSize = this.recsPerPage;
      vxm.jobs.getJobHistory(jhr);
    }
  }

  ///////////////////////////////////////////////

  getPrevious() {
    if (this.currentPage > 1) {
      const jhr = vxm.jobs.UserJobHistoryListRequest;
      jhr.resultPage = this.currentPage - 1;
      jhr.resultSize = this.recsPerPage;
      vxm.jobs.getJobHistory(jhr);
    }
  }

  ///////////////////////////////////////////////

  getLast() {
    const jhr = vxm.jobs.UserJobHistoryListRequest;
    jhr.resultPage = this.pageCount;
    jhr.resultSize = this.recsPerPage;
    vxm.jobs.getJobHistory(jhr);
  }

  ///////////////////////////////////////////////

  getFirst() {
    const jhr = vxm.jobs.UserJobHistoryListRequest;
    jhr.resultPage = 1;
    jhr.resultSize = this.recsPerPage;
    vxm.jobs.getJobHistory(jhr);
  }

  //////////////////////////////////////////////////

  get isLoggedIn(): boolean {
    return vxm.users.isLoggedIn;
  }

  //////////////////////////////////////////////////

  mounted() {
    if (vxm.users.isLoggedIn) {
      console.log(vxm.jobs.UserJobHistoryListRequest);
      this.recsPerPage = vxm.jobs.UserJobHistoryListRequest.resultSize;
    }
  }
}
